var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmployeesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6285 2.17C1.6285 0.974243 2.59786 0.00488281 3.79362 0.00488281H10.6372C11.8329 0.00488281 12.8023 0.974253 12.8023 2.17L12.8023 7.15234C11.5208 7.97224 10.6714 9.408 10.6714 11.0422C10.6714 12.1911 11.0913 13.242 11.786 14.0497C9.98149 15.2049 8.78539 17.227 8.78539 19.5284C8.78539 19.6901 8.80238 19.8479 8.83469 19.9999H2.34278C2.32018 19.9999 2.2977 19.9989 2.2754 19.9967H1.09487C0.503133 19.9967 0.0234375 19.517 0.0234375 18.9253C0.0234375 18.3336 0.503133 17.8539 1.09487 17.8539H1.62849L1.6285 8.03153H7.83942C8.33253 8.03153 8.73228 7.63179 8.73228 7.13867C8.73228 6.64556 8.33253 6.24581 7.83942 6.24581H1.6285V4.31733H5.85723C6.35035 4.31733 6.75009 3.91757 6.75009 3.42447C6.75009 2.93136 6.35035 2.53161 5.85723 2.53161H1.6285V2.17ZM18.1147 11.0422C18.1147 12.6045 16.8481 13.8709 15.2858 13.8709C13.7236 13.8709 12.4571 12.6045 12.4571 11.0422C12.4571 9.47986 13.7236 8.21337 15.2858 8.21337C16.8481 8.21337 18.1147 9.47986 18.1147 11.0422ZM15.2857 14.8139C12.6819 14.8139 10.5711 16.9247 10.5711 19.5284C10.5711 19.7889 10.7822 20 11.0426 20H19.529C19.7893 20 20.0004 19.7889 20.0004 19.5284C20.0004 16.9247 17.8896 14.8139 15.2857 14.8139Z",
    fill: "#CBCED4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeesIcon);
export default __webpack_public_path__ + "static/media/employeesIcon.fca5f319d5c3a4a75ec83a61b16149f0.svg";
export { ForwardRef as ReactComponent };